import logAmplitudeEvent from '@/utils/logAnalyticsEvent'

const Analytics = {
  install(Vue, opts = {}) {
    Vue.prototype.$analytics = {
      track: (event, attributes = {}) => {
        if (opts.debug) {
          console.log('[ANALYTICS] New event logged:', event, attributes)
        }

        logAmplitudeEvent(event, attributes)
      },
    }
  },
}

export default Analytics
